import { useContext, useState } from 'react';

import axios_api from '../Api';
import { API_URL, AUTH_TOKEN } from '../Context';


function errorText(error) {
  if (error.request?.status === 413) {
    return 'Размер файла превышает разрешенный размер на web-сервере';
  }
  const data = error.response?.data;
  if (typeof data === 'string') {
    return data;
  }
  return 'Не удалось отправить рассылку';
}


function BroadcastReport({report}) {
  const sent = Array.isArray(report?.sent) ? report.sent : [];
  const created = Array.isArray(report?.created) ? report.created : [];
  const errors = Array.isArray(report?.errors) ? report.errors : [];

  return (
    <div className="mt-3">
      <p>Уведомления созданы: {sent.length ? sent.join(', ') : 'нет'}</p>
      {created.length > 0 &&
        <p>Созданы лаборатории: {created.join(', ')}</p>
      }
      {errors.length > 0 &&
        <>
          <p className="mb-1">Не отправлено:</p>
          <ul>
            {errors.map((item) =>
              <li key={item.lab}>{item.lab}: {item.error}</li>
            )}
          </ul>
        </>
      }
    </div>
  );
}


export default function LabBroadcast() {
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const [text, setText] = useState('');
  const [labs, setLabs] = useState('');
  const [file, setFile] = useState(null);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [formError, setFormError] = useState(false);
  const [report, setReport] = useState(null);
  const [sending, setSending] = useState(false);

  function handleSubmit(event) {
    event.preventDefault();
    setFormError(false);
    setReport(null);

    if (!text.trim()) {
      setFormError('Не указан текст уведомления');
      return;
    }
    if (!labs.trim()) {
      setFormError('Не указан список лабораторий');
      return;
    }

    const body = new FormData();
    body.append('text', text.trim());
    body.append('labs', labs);
    if (file) {
      body.append('attachment', file);
    }

    setSending(true);
    axios_api.post(api_url + '/lab_broadcast/', body, {
      headers: {
        'Authorization': token,
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(
      (result) => {
        setSending(false);
        setReport(result.data);
        const sent = Array.isArray(result.data?.sent) ? result.data.sent : [];
        if (sent.length) {
          setText('');
          setLabs('');
          setFile(null);
          setFileInputKey((key) => key + 1);
        }
      },
      (error) => {
        setSending(false);
        setFormError(errorText(error));
        console.log(error);
      },
    );
  }

  return (
    <>
      <div className="row">
        <h3 className="m-3">Рассылка уведомлений</h3>
      </div>
      <p className="ms-3 mb-0">Номера лабораторий — каждый с новой строки. Файл необязателен.</p>
      <div className="m-3">
        <div className="lk-form">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="input-group my-3">
              <label className="mt-3 col-6">
                <p>Текст уведомления</p>
                <textarea
                  className="form-control"
                  rows="5"
                  style={{width: '400px'}}
                  value={text}
                  onChange={(event) => setText(event.target.value)}
                />
              </label>
            </div>
            <div className="input-group my-3">
              <label className="mt-3 col-6">
                <p>Номера лабораторий</p>
                <textarea
                  className="form-control"
                  rows="8"
                  style={{width: '400px'}}
                  value={labs}
                  onChange={(event) => setLabs(event.target.value)}
                  placeholder={'00123\n00456'}
                />
              </label>
            </div>
            <div className="input-group mt-3">
              <label>
                <p>Файл</p>
                <input
                  key={fileInputKey}
                  type="file"
                  className="form-control"
                  style={{width: '400px'}}
                  accept=".pdf,.doc,.docx"
                  onChange={(event) => setFile(event.target.files[0] || null)}
                />
              </label>
            </div>
            <p className="text-secondary mt-1"><small>pdf, doc или docx, максимальный размер файла 10 мб</small></p>
            {formError &&
              <p className="text-danger">{formError}</p>
            }
            <button type="submit" className="btn lk-button my-3" disabled={sending}>
              {sending ? 'Отправка…' : 'Отправить'}
            </button>
            {report &&
              <BroadcastReport report={report} />
            }
          </form>
        </div>
      </div>
    </>
  );
}
